import { plainToInstance } from 'class-transformer';
import {
	ModulesEnum,
	VehicleColorSearchDto,
} from '@splitsecondconnect/ultramarine-shared';
import { SelectItem } from '../../../../../../../shared/models/select-item.type';

export function mapDtoToModelVehicleColors(
	makes: VehicleColorSearchDto[],
): SelectItem<VehicleColorSearchDto>[] {
	return makes.map((make) => {
		const instance = plainToInstance(VehicleColorSearchDto, make);
		return {
			value: make,
			pillColor: make.color,
			displayValue: instance.displayValue(),
			shortDisplayValue: instance.shortDisplayValue(),
			extraDisplayValue: instance.extraDisplayValue(),
			pillDisplayValue: instance.pillDisplayValue(),
			module: ModulesEnum.VEHICLE_COLORS,
		};
	});
}
